// @flow

import React, { createContext, useCallback, useContext, useState } from "react";
import { Maybe } from "ramda-fantasy";

const FocusContext = createContext<*>({});

export const FocusArea = ({ children }: *) => {
  const focusState = useState({});
  return (
    <FocusContext.Provider value={focusState}>{children}</FocusContext.Provider>
  );
};

export const useRegisterFocusArea = (id: string) => {
  const [mapping, setMapping] = useContext(FocusContext);
  const setRef = useCallback(
    (ref: *) => {
      if (ref !== mapping[id]) {
        setMapping({ ...mapping, [id]: ref });
      }
    },
    [id, mapping, setMapping]
  );
  return setRef;
};

export const useFocusArea = (id: string) => {
  const [mapping] = useContext(FocusContext);
  const setFocus = useCallback(
    (ref: *) => {
      Maybe(mapping[id]).map(ref => ref.focus());
    },
    [id, mapping]
  );
  return setFocus;
};
